import { Types } from '@store/types';

const initialValue = {
	projectionChildTab: '',
	isShowLeftSidePanel: false,
	isShowSalesFunnelSummary: true,
	isShowEmptyState: false,
	selectedCRMProducts: []
};

const CRMCommonReducer = (state = initialValue, action) => {
	switch (action.type) {
		case Types.STORE_CRM_BRAND_PROFILE_RELATED_INFO:
			return { ...state, totalBrands: action.payload };
		case Types.STORE_PROJECTION_CHILD_TAB:
			return { ...state, projectionChildTab: action.payload };
		case Types.SET_CRM_LEFT_SIDE_PANEL:
			return { ...state, isShowLeftSidePanel: action.payload };
		case Types.TOGGLE_CRM_SALES_FUNNEL_SUMMARY:
			return { ...state, isShowSalesFunnelSummary: action.payload };
		case Types.TOGGLE_CRM_EMPTY_STATE:
			return { ...state, isShowEmptyState: action.payload };
		case Types.PRODUCT_CRM_IDS_STATE:
			return { ...state, selectedCRMProducts: action.payload };
		default:
			return state;
	}
};

export default CRMCommonReducer;
